import CrumbTrailStart from './CrumbTrailStart';

export default CrumbTrailStart;
